import type { CSSProperties } from 'react';

export enum ValidState {
  valid = 'valid',
  invalid = 'invalid'
}

export interface IContextOutlet {
  inMobile: boolean;
}

export enum EGlobalId {
  MENU_RIGHT = '_MENU_RIGHT_',
  MENU_TAB_ABILITY = '_MENU_TAB_ABILITY_',
  MENU_TAB_BUILD = '_MENU_TAB_BUILD_',
  MENU_TAB_CANVAS = '_MENU_TAB_CANVAS_',
  // MENU_TAB_CHAT = '_MENU_TAB_CHAT_',
  MENU_TAB_HOME = '_MENU_TAB_HOME_',
  MENU_TAB_MEMORY = '_MENU_TAB_MEMORY_',
  MENU_TAB_TASK = '_MENU_TAB_TASK_',
  MENU_TAB_AGENT = '_MENU_TAB_AGENT_',
  MENU_TAB_FRIENDS = '_MENU_TAB_FRIENDS_',
  GUIDE_CREATE_TWO = '_GUIDE_CREATE_TWO_',
  BUTTON_CHAT = '_BUTTON_CHAT_',
  MIND_CARD = 'MIND_CARD',
  CONTENT_SECONDARY_PANEL = '_CONTENT_SECONDARY_PANEL_',
  RETURN_ICON_CONTAINER = '_RETURN_ICON_CONTAINER_',
  MOBILE_RETURN_ICON_CONTAINER = '_MOBILE_RETURN_ICON_CONTAINER_',
  MOBILE_MARKETPLACE_SEARCH = '_MOBILE_MARKETPLACE_SEARCH_',
  CANVAS_CONTENT_FOOTER = '_CANVAS_CONTENT_FOOTER_'
}

export interface ReactClassNameInterface {
  className?: string;
  style?: CSSProperties;
  children?: React.ReactNode;
}

export enum EGlobalLocalStorageKey {
  userId = 'userId'
}

export interface PagingResponse<T> {
  list: T[];
  total: number;
}
